import { login as loginAPI } from "../api/authAPI";

export const login = async (email, password) => {
  try {
    const data = await loginAPI(email, password);
    localStorage.setItem("token", data.token);
    return data;
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error("Login failed:", error);
    }
    throw error;
  }
};

export const logout = () => {
  localStorage.removeItem("token");
};

export const getToken = () => {
  return localStorage.getItem("token");
};

export const isLoggedIn = () => {
  return !!getToken();
};
